/**
 * useAvailableModels — text-generation model dropdown source (ADR-019 Phase 3).
 *
 * Fetches /api/v1/text-generation/models (static + registry-active models,
 * see backend _list_available_models). Falls back to the historical static
 * MODELS constant while loading or on error, so the dropdown is never empty.
 */
import { useQuery } from '@tanstack/react-query';
import { getAvailableModels } from '@/lib/api/textGeneration';
import { MODELS } from './textToolSettingsConstants';

export function useAvailableModels() {
  const { data } = useQuery({
    queryKey: ['text-generation', 'available-models'],
    queryFn: getAvailableModels,
    staleTime: 5 * 60 * 1000,
  });
  return data && data.length > 0 ? data : MODELS;
}
